"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampusMediaService = void 0;
const axios_1 = require("axios");
const abstract_service_1 = require("../shared/abstract-service");
class CampusMediaService extends abstract_service_1.AbstractService {
    uploadImage(file, filename) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', file, filename);
            const contentTypeHeader = {
                'Content-Type': 'multipart/form-data'
            };
            const response = yield axios_1.default.post(`${this.baseUrl}/images`, formData, {
                headers: Object.assign(Object.assign({}, this.getHeaders()), contentTypeHeader)
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getAllUserImages() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}/images`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getImage(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}/images/${key}`, {
                headers: this.getHeaders()
            });
            if (response.status === 404) {
                throw new Error(response.statusText);
            }
        });
    }
    deleteImage(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.delete(`${this.baseUrl}/images/${key}`, {
                headers: this.getHeaders()
            });
            if (response.status === 404) {
                throw new Error(response.statusText);
            }
        });
    }
    getUserAvatar() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(`${this.baseUrl}/avatar`, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    updateUserAvatar(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.put(`${this.baseUrl}/avatar`, {
                body: body
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
}
exports.CampusMediaService = CampusMediaService;
